import createIcon from '../../createIcon';

/**
 * @component @name TimerOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNzA5NiAxLjE5NTMxSDkuNzA5NjFWMy4xOTUzMUgxNS43MDk2VjEuMTk1MzFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuNzA5NiA4LjE5NTMxVjEwLjM2NTNMMjAuNjg5NiAxNy4zNDUzQzIxLjMzOTYgMTYuMTA1MyAyMS43MDk2IDE0LjY5NTMgMjEuNzA5NiAxMy4xOTUzQzIxLjcwOTYgMTEuMDc1MyAyMC45Njk2IDkuMTI1MzEgMTkuNzM5NiA3LjU4NTMxTDIxLjE1OTYgNi4xNjUzMUMyMC43Mjk2IDUuNjU1MzEgMjAuMjU5NiA1LjE3NTMxIDE5Ljc0OTYgNC43NTUzMUwxOC4zMjk2IDYuMTc1MzFDMTYuNzc5NiA0LjkzNTMxIDE0LjgyOTYgNC4xOTUzMSAxMi43MDk2IDQuMTk1MzFDMTEuMjA5NiA0LjE5NTMxIDkuNzk5NjEgNC41NjUzMSA4LjU1OTYxIDUuMjE1MzFMMTEuNTM5NiA4LjE5NTMxSDEzLjcwOTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMy41MTk2MSAzLjAwNTMxTDIuMDk5NjEgNC40MTUzMUw1LjQ5OTYxIDcuODE1MzFDNC4zNzk2MSA5LjMxNTMxIDMuNzA5NjEgMTEuMTc1MyAzLjcwOTYxIDEzLjE5NTNDMy43MDk2MSAxOC4xNjUzIDcuNzI5NjEgMjIuMTk1MyAxMi43MDk2IDIyLjE5NTNDMTQuNzI5NiAyMi4xOTUzIDE2LjU4OTYgMjEuNTI1MyAxOC4wODk2IDIwLjQwNTNMMjAuNDg5NiAyMi44MDUzTDIxLjg5OTYgMjEuMzk1M0wzLjUxOTYxIDMuMDA1MzFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TimerOff = createIcon('TimerOff', [
  ['path', { d: 'M15.7096 1.19531H9.70961V3.19531H15.7096V1.19531Z', key: '1m4rg1' }],
  [
    'path',
    {
      d: 'M13.7096 8.19531V10.3653L20.6896 17.3453C21.3396 16.1053 21.7096 14.6953 21.7096 13.1953C21.7096 11.0753 20.9696 9.12531 19.7396 7.58531L21.1596 6.16531C20.7296 5.65531 20.2596 5.17531 19.7496 4.75531L18.3296 6.17531C16.7796 4.93531 14.8296 4.19531 12.7096 4.19531C11.2096 4.19531 9.79961 4.56531 8.55961 5.21531L11.5396 8.19531H13.7096Z',
      key: 't4cymg',
    },
  ],
  [
    'path',
    {
      d: 'M3.51961 3.00531L2.09961 4.41531L5.49961 7.81531C4.37961 9.31531 3.70961 11.1753 3.70961 13.1953C3.70961 18.1653 7.72961 22.1953 12.7096 22.1953C14.7296 22.1953 16.5896 21.5253 18.0896 20.4053L20.4896 22.8053L21.8996 21.3953L3.51961 3.00531Z',
      key: 'k4c44e',
    },
  ],
]);

export default TimerOff;
